import type { RouteConfig } from 'vue-router';
import { Role } from '@/modules/shared/types';

const route: RouteConfig = {
    path: '/:customer',
    name: 'home',
    component: () => import(/* webpackChunkName: "dashboard" */ '../portfolio/PortfolioFavoritesView.vue'),
    // component: () => import(/* webpackChunkName: "dashboard" */ './FavoritesView.vue'),
    meta: {
        role: Role.USER,
        license: [],
        authenticated: true,
        navbar: true,
        footer: true,
        settingsTabs: false,
        portfolioTabs: true,
        onboarding: true,
        notifications: true,
    },
};

export { route };
